import styled from "styled-components";

export const StyledResult = styled.p`
  color:rgba(0, 127, 165, .6);
  text-align: center;
  font-size: 20px;
  margin-top: 20px;
`;